{
    "form": {
        "required": "This field is required",
        "msgRadioCheck": "Please select an option",
        "msgDropdown": "Please make a selection",
        "msgPhoneRequired": "Please fill in a valid phone number",
        "msgPasswordInvalid": "Password must match the criteria below. Please try again.",
        "msgPasswordUppercase": "Password must contain at least one uppercase.",
        "msgPasswordLowercase": "Password must contain at least one lowercase.",
        "msgPasswordDigit": "Password must contain at least one digit.",
        "msgPasswordSpecChar": "Password must contain special characters from @#$%&.",
        "msgEmail": "This is not a correct email format",
        "msgEmailGuestConfirm": "Password not matching"
    },
    "dropdown": {
        "noresult": "No results found"
    }
}
